module.exports = __webpack_public_path__ + "static/img/leisure.58218c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/home/meeting-room/leisure.png
// module id = o8gQ
// module chunks = 1